'use client';

import { freddyTheme, Link } from '@coolblue-development/freddy';
import selectItemTrigger from '@coolblue-development/ga4-events/triggers/ComparisonTool/selectItemTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitle, ProductTitleTitle } from '@coolblue-development/next-patterns/client';
import type { ReactNode } from 'react';

type Props = {
  url: string;
  children: ReactNode;
  analyticsProps: {
    index: number;
    total_indices: number;
    item_id: number;
  };
};

const Title = ({ url, children, analyticsProps }: Props) => {
  const { trackEvent } = useAnalytics();

  function trackItemSelection() {
    trackEvent(
      selectItemTrigger({
        ...analyticsProps,
        sub_feature: 'clicked_item',
        method: 'title'
      })
    );
  }

  return (
    <ProductTitle>
      <ProductTitleTitle>
        <Link
          fontWeight={freddyTheme.typography.fontWeight.openSans.bold}
          href={url}
          onClick={trackItemSelection}
        >
          {children}
        </Link>
      </ProductTitleTitle>
    </ProductTitle>
  );
};

export default Title;
